/**
 * All UI related shared state should be placed here.
 * FYI: Bases on current setup, on each reload state would be back to initial
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '~/redux/store'
import { logout } from '~/auth/slices/auth.slice'

interface UIState {
  previewSite: boolean
}

const initialState: UIState = {
  previewSite: false,
}

const slice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    togglePreviewSite: (state, action: PayloadAction<boolean>) => ({
      ...state,
      previewSite: action.payload,
    }),
  },

  extraReducers: (builder) => {
    builder.addCase(logout, (state) => {
      state.previewSite = false
    })
  },
})

export const selectPreviewSite = (state: RootState): UIState['previewSite'] => {
  return state.ui.previewSite
}

export const { togglePreviewSite: togglePreviewSiteActionCreator } = slice.actions

export default slice.reducer
